import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    '&&': {
      marginBottom: SPACES.xxxl,
      maxWidth: 900,
    },
  },
  breadcrumbs: {
    '&&': {
      '& .MuiBreadcrumbs-ol': {
        rowGap: SPACES.xs,
      },

      '& .MuiBreadcrumbs-separator': {
        marginBottom: `-${SPACES.xxl}`,
      },
    },
  },
  item: {
    '&&': {
      height: '58px',

      padding: SPACES.l,

      display: 'flex',
      alignItems: 'center',

      borderRadius: 10,
      backgroundColor: theme.palette.custom.secondary,

      [theme.breakpoints.down('tablet')]: {
        maxWidth: 142,
      },
      [theme.breakpoints.up('tablet')]: {
        minWidth: 80,
        maxWidth: 212,
      },
    },
  },
  itemImage: {
    '&&': {
      marginRight: SPACES.xxs,
      width: 36,
      height: 36,
    },
  },
  itemTitle: {
    '&&': {
      color: theme.palette.custom.darkBlue2,
      fontSize: FONTS.SIZES.m,
      fontWeight: FONTS.WEIGHTS.normal,

      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',

      [theme.breakpoints.down('tablet')]: {
        maxWidth: 70,
      },
      [theme.breakpoints.up('tablet')]: {
        maxWidth: 140,
      },
    },
  },
  itemSubtitle: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.light,
      color: theme.palette.custom.darkBlue2,
      fontSize: FONTS.SIZES.s,

      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',

      [theme.breakpoints.down('tablet')]: {
        maxWidth: 70,
      },
      [theme.breakpoints.up('tablet')]: {
        maxWidth: 100,
      },
    },
  },
  itemlabel: {
    '&&': {
      textAlign: 'center',
      color: theme.palette.custom.grey3,
      fontSize: FONTS.SIZES.s,
      fontWeight: FONTS.WEIGHTS.light,
    },
  },

  scanWrapper: {
    [theme.breakpoints.down('tablet')]: {
      display: 'flex',
      justifyContent: 'flex-end',
    },

    [theme.breakpoints.up('tablet')]: {
      display: 'none',
    },
  },
}))
